import styled from "styled-components";

export const ImageInfo = styled.img`
    width: 90px;
    height: 90px;
    border-radius: 1rem;
    margin: 0 1vw 0 1vw;
`;